export default __webpack_public_path__ + "static/media/delievers20.75f8c32d.jpeg";